module.exports = __webpack_public_path__ + "static/media/deep-experience.e33fa016.svg";